// extracted by mini-css-extract-plugin
export default {"works":"works_works__7QxtB"};